<template>
  <div>
    <b-overlay
      :show="loading"
      :style="{
        width: fullWidth ? '' : `${pw}px`,
        height: fullWidth ? '' : `${ph}px`,
      }"
    >
      <div
        class="image-uploader flex-center-vertically text-center"
        style="min-height: 150px; height: auto; border: 1px dashed"
        :style="{
          borderColor: activeColor,
          cursor: readonly ? '' : 'pointer',
          backgroundColor: readonly ? secondary : '',
          width: fullWidth ? '' : `${pw}px`,
          height: fullWidth ? '' : `${ph}px`,
        }"
        ref="dragDropBox"
        @click="chooseImage"
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
      >
        <div v-if="!value && !image">
          <feather-icon
            icon="ImageIcon"
            size="30"
            :style="{
              color: readonly ? '#ffffff' : activeColor,
            }"
          />
          <div
            class="mt-2"
            :style="{
              color: readonly ? '#ffffff' : activeColor,
            }"
          >
            {{ $t("general.clickOrDragDropToUpload") }}
          </div>
        </div>
        <div v-if="value || image">
          <img
            class="img-fluid"
            :src="value ? value : image"
            alt=""
            :style="{
              height: fullWidth ? '' : `${ph}px`,
            }"
          />
        </div>
      </div>
      <input
        type="file"
        style="display: none"
        multiple
        name="fields[assetsFieldHandle][]"
        id="assetsFieldHandle"
        class="w-px h-px opacity-0 overflow-hidden absolute"
        @change="onChange"
        ref="fileInput"
        accept=".pdf,.jpg,.jpeg,.png"
      />
    </b-overlay>
  </div>
</template>

<script>
import { $themeConfig } from "@themeConfig";
import Repository from "@/repositories/RepositoryFactory";
import { BOverlay } from "bootstrap-vue";

const FileRepository = Repository.get("file");

export default {
  delimiters: ["${", "}"],

  components: {
    BOverlay,
  },

  data: function () {
    return {
      loading: false,
      filelist: [],
    };
  },

  props: {
    image: {},
    value: {},
    size: {},
    pw: {},
    ph: {},
    path: {
      type: String,
      default: "image",
    },
    fullWidth: {
      type: Boolean,
      default: true,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Image",
    },
    readonly: {},
  },

  methods: {
    onChange() {
      if (this.readonly) {
        return;
      }

      this.filelist = [...this.$refs.fileInput.files];
      var reader = new FileReader();
      reader.onload = (e) => {
        const file = {
          path: this.path,
          file: e.target.result,
          filename: this.filelist[0].name,
          filesize: this.filelist[0].size,
        };
        this.upload(file);
      };
      reader.readAsDataURL(this.filelist[0]);
    },
    upload(file) {
      this.loading = true;
      FileRepository.upload(file)
        .then((response) => {
          if (response?.data?.data) {
            this.$emit("input", response?.data?.data.fileUrl);
            this.$emit("change", response?.data?.data.fileUrl);
          }
        })
        .catch()
        .then(() => {
          this.loading = false;
        });
    },
    remove() {
      this.filelist.splice(0, 1);
      this.$emit("input", null);
      this.$emit("change", null);
    },
    dragover(event) {
      if (this.readonly) {
        return;
      }

      event.preventDefault();
      this.activeColor = this.primary;
    },
    dragleave(event) {
      if (this.readonly) {
        return;
      }
      this.activeColor = this.secondary;
    },
    drop(event) {
      if (this.readonly) {
        return;
      }
      event.preventDefault();
      this.$refs.fileInput.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
    },

    chooseImage() {
      if (this.readonly) {
        return;
      }
      this.$emit("blur", null);
      this.$refs.fileInput.value = null;
      this.$refs.fileInput.click();
    },
  },
  setup() {
    // App Name
    const { primary, secondary } = $themeConfig.color;

    let activeColor = secondary;

    return {
      primary,
      secondary,
      activeColor,
    };
  },
};
</script>

<style scoped>
.flex-center-vertically {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
</style>
